<template>
  <ul class="menu-list">
    <MenuItem
      v-for="item in items"
      :key="getMenuItemUniqueIdentifier(item.name)"
      :item="item"
      :selected-item="selectedItem"
      :checkbox-style="checkboxStyle"
      v-on="$listeners"
    >
      <MenuList
        v-if="item.subitems"
        :items="item.subitems"
      />
    </MenuItem>
  </ul>
</template>

<script>
import MenuItem from './menu-item';
import { RandomId } from '@/shared/lib/random';

const { generateRandomId } = RandomId();

export default {
  name: 'MenuList',
  props: {
    items: {
      type: Array,
      default: null,
      required: false,
    },
    selectedItem: {
      type: Object,
      default: () => {},
      required: false,
    },
    checkboxStyle: {
      type: String,
      default: 'inline',
      validator: (value) => ['inline', 'styled'].includes(value),
    },
  },
  components: { MenuItem },
  methods: {
    generateRandomId,
    getMenuItemUniqueIdentifier(name) {
      return this.generateRandomId(`menu-item-${name}-`);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-list {
  background-color: #ffffff;
  border: 1px solid #E5E5E7;
  border-radius: 6px;
  padding: 12px 8px;
  list-style: none;
  margin: 0;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: #09090B;
  box-shadow: 0px 2px 4px -1px #0000000F, 0px 4px 6px -1px #0000001A;
}
</style>
